export enum WrapperPlatform {
  iOS = 'ios',
  Android = 'android',
  None = 'none',
}
